<template>
  <div class="u-wrapper-panel" ref="container">
    <video-player
      :options="options"
      ref="video"
      @timeupdate="onPlayerTimeupdate"
      @ready="onPlayerReady"
      class="u-wrapper-panel"
    />
    <div class="subtitles u-center" :class="{'is-fullscreen': isFullScreen}" ref="subtitles">
      <!-- <div v-if="currentTime > 1 && currentTime < 10">
        plop
      </div> -->
      <div v-html="sub.text" v-for="sub in subs" v-if="currentTime > sub.startTime && currentTime < sub.endTime" class="t-text" />
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import axios from 'axios'
import parser from 'subtitles-parser'

export default {
  components: {
    videoPlayer
  },
  computed: {
    options () {
      return {
        muted: false,
        language: 'en',
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: this.src
        }],
        poster: this.poster,
        fluid: true,
        fill: this.fill
      }
    }
  },
  props: {
    subtitles: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    fill: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      width: 0,
      height: 0,
      subs: [],
      currentTime: 0,
      isFullScreen: false
    }
  },
  created () {
    this.computeSubtitles()
  },
  methods: {
    onResize () {
      this.width = this.$refs.container.offsetWidth
      this.height = this.$refs.container.offsetHeight

      if (this.player) {
        // this.player.width = this.width
        // this.player.height = this.height
        // console.log('this.player.height', this.player)
      }
    },
    onPlayerTimeupdate (player) {
      // in seconds
      this.currentTime = player.currentTime()
    },
    computeSubtitles () {
      this.subs.splice(0, this.subs.length)
      axios.get(this.subtitles, {
        responseType: 'text'
      }).then(res => {
        const decoder = new TextDecoder('windows-1252')
        let subtitles = parser.fromSrt(res.data, true)
        subtitles.forEach((sub, index) => {
          sub.startTime = sub.startTime * .001
          sub.endTime = sub.endTime * .001
          // sub.text = decoder.decode([sub.text])

          this.subs.push(sub)
        })
      })
    },
    encodeUtf8 (s) {
      for(var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode; ++i < l;
          s[i] = (c = s[i].charCodeAt(0)) >= 127 ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f)) : s[i]
      );
      return s.join("")
    },
    decodeUtf8 (s) {
      for(var a, b, i = -1, l = (s = s.split("")).length, o = String.fromCharCode, c = "charCodeAt"; ++i < l;
          ((a = s[i][c](0)) & 0x80) &&
          (s[i] = (a & 0xfc) == 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) == 0x80 ?
          o(((a & 0x03) << 6) + (b & 0x3f)) : o(128), s[++i] = "")
      )
      return s.join("");
    },
    onPlayerReady (player) {
      this.player = player
      this.player.el_.appendChild(this.$refs.subtitles)
      this.onResize()
    }
  },
  beforeDestroy () {
    this.player.el_.removeChild(this.$refs.subtitles)
  }
}
</script>

<style lang="stylus">
@import '~@/../node_modules/video.js/dist/video-js.css'

.subtitles
  position absolute
  bottom 40px
  left 20px
  right 20px
  
  &.is-fullscreen
    position fixed

.video-js .vjs-big-play-button
  top 50%
  left 50%
  transform translate(-50%, -50%)
</style>